import { FlatNode } from '../pages/mindmap/types';

export const getBottomRightCoords = (node: FlatNode) => {
  if (node.x == null || node.y == null) {
    throw new Error('Missing x or y property from node.');
  }
  return {
    x: node.x + node.width,
    y: node.y + node.height,
  };
};
